export default __webpack_public_path__ + "84b55d6e68bec0e790c5b2e19b808151.png";